import {
  Box,
  Button,
  IconButton,
  Modal,
  Stack,
  Typography,
} from "@mui/material";

import CloseIcon from "@mui/icons-material/Close";
import SaveIcon from "@mui/icons-material/Save";
import React from "react";
import { FormProvider, useForm } from "react-hook-form";
import { DataGridContext } from "../../../../context/DataGridContext";
import NewCategoryForm from "./NewCategoryForm";
import NewItemForm from "./NewItemForm";
import NewListForm from "./NewListForm";
import NewPrinterForm from "./NewPrinterForm";
import NewStaffForm from "./NewStaffForm";
import TagModules from "./TagModules";

import { LoadingButton } from "@mui/lab";
import NewMacroModal from "../../../../components/NewMacroModal";
import NewRoleModal from "../../../../components/NewRoleModal";
import NewSiteForm from "./NewSiteForm";

export default function GridModal({
  modalConfig,
  setModalConfig,
  gridList,
  modalVisible,
  setModalVisible,
  processRowUpdate,
  contextName,
  table,
  isSaving,
  setIsSaving,
}) {
  const methods = useForm({
    defaultValues: modalConfig?.editRow?.row,
  });

  React.useEffect(() => {
    let defaultValues;
    if (modalConfig.isNew === true) {
      defaultValues = gridList.defaultValues;
    } else defaultValues = modalConfig?.editRow?.row;
    methods.reset({ ...defaultValues });
  }, [
    modalConfig?.editRow?.row,
    setModalVisible,
    modalVisible,
    setModalConfig,
  ]);

  const { setNewData } = React.useContext(DataGridContext);

  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    borderRadius: "10px",
    width: gridList.gridPage === "policies" ? 1000 : 410,
    maxHeight: "90vh",
    // height: "100%",
    // minHeight:
    // 	// 100 +
    // 	typeof modalColumns !== "undefined" ? modalColumns.length * 70 : 400,
    bgcolor: "white",
    boxShadow: 24,
    // p: 4,
    overflow: "auto",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    // padding: 0,
    gap: 2,
    flexDirection: "column",
  };

  const onSubmit = async () => {
    setIsSaving(true);
    let form = methods.getValues();

    if (gridList.gridPage === "printers") {
      let obj = {};
      form.modalValues.map((val) => {
        obj[val.Site] = val.Printers;
      });
      form.printer_details.sites = obj;
    }
    if (gridList.gridPage === "items") {
      form = form.plus;
    }
    console.log("form", form);
    processRowUpdate(form, modalConfig.editRow.row, modalConfig.isNew);
    if (modalConfig.isNew) {
      setNewData(true);
    }

    // setModalVisible(false);
  };

  return (
    <Modal open={modalVisible} sx={{ overflow: "hidden" }}>
      <>
        <FormProvider {...methods}>
          <form onSubmit={methods.handleSubmit(onSubmit)}>
            <Box sx={style}>
              <Box sx={style2}>
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "space-between",
                    alignItems: "center",
                  }}
                >
                  <Typography variant="h3">
                    {modalConfig.isNew === true ? "New" : "Edit"}{" "}
                    {gridList.modalTitle}
                  </Typography>

                  <IconButton
                    aria-label="close"
                    sx={{ alignSelf: "flex-end" }}
                    onClick={() => {
                      setModalConfig({
                        focusField: "",
                        editRow: null,
                        open: false,
                      });
                      setModalVisible(false);
                      methods.reset();
                    }}
                  >
                    <CloseIcon />
                  </IconButton>
                </Box>

                <Stack
                  direction="column"
                  justifyContent="flex-start"
                  alignItems="flex-start"
                  spacing={2}
                  sx={{ mt: 2, mb: 2 }}
                >
                  {gridList.gridPage === "screens" ? (
                    <NewListForm methods={methods} modalConfig={modalConfig} />
                  ) : gridList.gridPage === "items" ? (
                    <NewItemForm methods={methods} modalConfig={modalConfig} />
                  ) : gridList.gridPage === "tags" ? (
                    <TagModules
                      methods={methods}
                      modalConfig={modalConfig}
                      table={table}
                    />
                  ) : gridList.gridPage === "printers" ? (
                    <NewPrinterForm
                      methods={methods}
                      modalConfig={modalConfig}
                      table={table}
                    />
                  ) : gridList.gridPage === "categories" ||
                    gridList.gridPage === "majorcategories" ? (
                    <NewCategoryForm
                      methods={methods}
                      table={table}
                      gridList={gridList}
                      modalConfig={modalConfig}
                    />
                  ) : gridList.gridPage === "staff" ? (
                    <NewStaffForm
                      modalConfig={modalConfig}
                      methods={methods}
                      table={table}
                    />
                  ) : gridList.gridPage === "users" ? (
                    <NewRoleModal
                      methods={methods}
                      table={table}
                      modalConfig={modalConfig}
                      type="users"
                    />
                  ) : gridList.gridPage === "userTypes" ? (
                    <NewRoleModal
                      methods={methods}
                      table={table}
                      type="userTypes"
                      modalConfig={modalConfig}
                    />
                  ) : gridList.gridPage === "policies" ? (
                    <NewRoleModal
                      methods={methods}
                      table={table}
                      type="policies"
                      modalConfig={modalConfig}
                    />
                  ) : gridList.gridPage === "macro" ? (
                    <NewMacroModal
                      methods={methods}
                      table={table}
                      context="macro"
                      modalConfig={modalConfig}
                    />
                  ) : gridList.gridPage === "paymentMethod" ? (
                    <NewMacroModal
                      methods={methods}
                      table={table}
                      context="paymentMethod"
                      modalConfig={modalConfig}
                    />
                  ) : gridList.gridPage === "analysisCategory" ? (
                    <NewMacroModal
                      methods={methods}
                      table={table}
                      context="analysisCategory"
                      modalConfig={modalConfig}
                    />
                  ) : gridList.gridPage === "sites" ? (
                    <NewSiteForm
                      methods={methods}
                      table={table}
                      context="site"
                      modalConfig={modalConfig}
                    />
                  ) : (
                    <NewMacroModal
                      methods={methods}
                      table={table}
                      context={gridList.gridPage}
                      modalConfig={modalConfig}
                    />
                  )}
                </Stack>

                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "space-between",
                  }}
                >
                  <Button
                    variant="outlined"
                    size="medium"
                    sx={{ alignSelf: "flex-end" }}
                    onClick={() => methods.reset()}
                  >
                    Reset form
                  </Button>

                  <LoadingButton
                    loading={isSaving}
                    variant={!isSaving ? "gradient" : "outlined"}
                    loadingPosition="start"
                    startIcon={<SaveIcon />}
                    disabled={isSaving}
                    type="submit"
                    sx={{ height: "100%", width: 100 }}
                  >
                    <span>Save</span>
                  </LoadingButton>
                </Box>
              </Box>
            </Box>
          </form>
        </FormProvider>
      </>
    </Modal>
  );
}

const style2 = {
  height: "100%",
  width: "100%",
  p: 4,
  overflow: "hidden",
  display: "flex",
  justifyContent: "flex-start",
  gap: 2,
  flexDirection: "column",
  overflowY: "scroll",
  "&::-webkit-scrollbar": {
    width: "6px",
  },
  "&::-webkit-scrollbar-track": {
    backgroundColor: "#f5f5f5",
  },
  "&::-webkit-scrollbar-thumb": {
    borderRadius: "10px",
    boxShadow: "inset 0 0 10px rgba(0,0,0,.3)",
  },
};
